import { AuthOnFileRpaErrorType } from "../../../enums/authOnFileRpaErrorType";

type ErrorType =
  | AuthOnFileRpaErrorType.REGIMEN_NOT_FOUND
  | AuthOnFileRpaErrorType.BUSINESS_OFFICE_ROWS_NOT_FOUND
  | AuthOnFileRpaErrorType.VISIT_DATE_CONTENT_NOT_FOUND;

export const formatErrorType = (errorType: string | undefined): string => {
  if (!errorType) return "Unknown Error";

  const errorMessages: Record<ErrorType, string> = {
    [AuthOnFileRpaErrorType.REGIMEN_NOT_FOUND]: "Regimen not found",
    [AuthOnFileRpaErrorType.BUSINESS_OFFICE_ROWS_NOT_FOUND]:
      "Business Office not found",
    [AuthOnFileRpaErrorType.VISIT_DATE_CONTENT_NOT_FOUND]:
      "No treatment found on date of service",
  };

  return errorMessages[errorType as ErrorType] || errorType;
};
